module.exports = __webpack_public_path__ + "static/media/2@2x.fc053c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity_100/2@2x.png
// module id = 373
// module chunks = 0